/**
 * A cheque's state as people read it. RELEASED (handed to the payee) is not a stored
 * status — it is a release date on a cheque that is still "pending" — so it is worked
 * out here; once the cheque clears it reads Cleared. Server mirror:
 * `chequeStatusLabel` in `server/src/lib/released-checks.ts`.
 *
 * `none` is what a cheque with no status yet is called (its voucher is not approved).
 */
export function chequeStatusLabel(
  status: string | null | undefined,
  releasedAt?: string | Date | null,
  none = ""
): string {
  if (!status) return none;
  if (status === "pending" && releasedAt) return "Released";
  return status.charAt(0).toUpperCase() + status.slice(1);
}
